import {
  GenericForm,
  GenericFormLogicalField,
  genericBeforeValidate_removeDefaultKeyedError,
  genericValidate_textField,
  ValidationEvent,
} from "../../../hooks";

export const maxGiftcardNumberLength = 19;

interface GiftcardNumberFormLogicProps {
  required?: boolean;
}

export const giftcardNumberFormLogic = <
  Form extends GenericForm,
  App extends unknown
>({ required }: GiftcardNumberFormLogicProps = {}): GenericFormLogicalField<
  Form,
  App
> => ({
  validationEvents: [
    ValidationEvent.onChange,
    ValidationEvent.onBlur,
    ValidationEvent.onSubmit,
  ],
  beforeValidate: genericBeforeValidate_removeDefaultKeyedError,
  validate: genericValidate_textField({
    required,
    trim: true,
    maxLength: maxGiftcardNumberLength,
  }),
});
